<template>
  <CContainer class="d-flex align-items-center">
    <CRow class="w-100 justify-content-center">
      <CCol md="6 py-5">
        <div class="w-100 py-5">
          <div class="clearfix d-flex flex-column align-items-center">
            <h4 class="pt-3">{{ $t('downloadFilePage.text.fileReady') }}</h4>
            <p class="text-muted">{{ $t('downloadFilePage.text.tryAgain') }}</p>
            <CButton color="primary" class="py-2 px-4 mt-4" :disabled="!fileData" @click="getParamsDownload($route.params.file)">
              {{ $t('downloadFilePage.button.download') }}
            </CButton>
            <div class="mt-5">
              <a style="cursor: pointer" @click="$router.go(-1)">{{ $t('downloadFilePage.link.backLastPage') }}</a>
            </div>
          </div>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import services from '@/services.js'
import fileDownload from 'js-file-download'
export default {
  name: 'donwload',
  data() {
    return {
      fileData: false,
      organizationId: null,
    }
  },

  mounted() {
    this.organizationId = this.$route.params.organizationId

    if (this.$route.params.file) {
      setTimeout(() => {
        this.getParamsDownload(this.$route.params.file)
      }, 1000)

      this.getFile()
    }
  },

  methods: {
    getParamsDownload(fileName) {
      this.messages = []
      services
        .downloadExport(this.organizationId, fileName)
        .then(response => {
          fileDownload(response.data, fileName, response.headers['content-type'])
        })
        .catch(({ response }) => {
          this.messages.push({
            status: 'danger',
            text: response.data.message || response.statusText,
          })
        })
    },

    async getFile() {
      try {
        // this.fileData = await services.download(this.$router.name)
        setTimeout(() => {
          this.fileData = true
        }, 10000)
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>
